var map = {
	"./live/live.module": [
		"./src/app/live/live.module.ts",
		"default~live-live-module~mobile-mobile-module~shared-shared-module",
		"common",
		"live-live-module"
	],
	"./mobile/mobile.module": [
		"./src/app/mobile/mobile.module.ts",
		"default~live-live-module~mobile-mobile-module~shared-shared-module",
		"common",
		"mobile-mobile-module"
	],
	"./shared/shared.module": [
		"./src/app/shared/shared.module.ts",
		"default~live-live-module~mobile-mobile-module~shared-shared-module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;